'use strict';
import { module } from '../app';

module.directive('findings', [
  'findingsViewModel', 'eventsMgr', '$rootScope',
  function (FindingsViewModel, eventsMgr, $rootScope) {
    return {
      templateUrl: 'views/templates/findings.html',
      scope: {
        problemsList: '=problems',
        setSvgAction: '=',
        viewOnly: '=',
        worklistId: '=',
        diagramImage: '=',
        findingEditing: '=',
        oldDiagramDescription: '=',
        showSaveButton: '=',
        customSaveAction: '=',
        setDiagramEditor: '=',
        saveDiagramAction: '='
      },
      link: function ($scope, elm, attrs) {

        let vm = new FindingsViewModel($scope.worklistId, $scope);
        $scope.vm = vm;


        vm.setSvgAction = $scope.setSvgAction;
        vm.setDiagramEditor = $scope.setDiagramEditor;
        vm.saveDiagramAction = $scope.saveDiagramAction;
        //vm.viewOnly = $scope.viewOnly;
        vm.diagramImage = $scope.diagramImage;
        vm.oldDiagramDescription = $scope.oldDiagramDescription;

        // vm.init($scope.problems, $scope.setSvgAction, $scope.viewOnly);

        $scope.$watch('vm.selectedElement', function () {
          if (vm.selectedElement) {
            vm.commentText = vm.selectedElement.Comments;
          } else {
            vm.commentText = '';
          }
        });

        $scope.$watchCollection('problemsList', function () {
          let l = $scope.problemsList;

          if (l) {
            let index = 1;
            l.forEach(function (item) {
              item.index = index;
              index++;
            });
          }

          eventsMgr.send('diagram:list:updated', l);
        });

        $scope.$on('$destroy', () => {
          //console.log('re-enable scrolling');
          document.ontouchmove = function (e) {
            return true;
          };
        });

        setTimeout(() => {
          //console.log('disable scrolling');
          document.ontouchmove = function (e) {
            e.preventDefault();
            return false;
          };
        }, 500);
      }
    };
  } ]);



// WEBPACK FOOTER //
// ./src/scripts/directives/findings.js